import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import { currentDateEndTime, currentDateStartTime } from "../../lib/functions";

export const fetchExpenseRecognition = createAsyncThunk(
  "expenseRecognition/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      let url = "/reports/expense-recognition-record";
      if (filters.recordType === "with details") {
        url = "/accounts/get-recognition-with-details";
      }
      if (filters.filterType === "By Expense") {
        url = "/reports/get-expense-record-details";
      }

      const payload = {
        selectedFilterType: filters.filterType,
        expId: filters.expenseId || null,
        employeeId: filters.employeeId || null,
        userId: filters.userId || null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };

      const res = await postData(url, payload);

      let mapped = [];

      if (filters.recordType === "with details") {
        mapped = res.data.map((row, idx) => ({
          id: row.id || idx,
          date: row.created_date,
          createdBy: row.full_name,
          description: row.narration,
          details: row.details || [],
          status: row.status === "p" ? "Pending" : "Approved",
        }));
      } else {
        mapped = res.data.map((row, idx) => ({
          id: row.id || idx,
          date: row.created_date,
          createdBy: row.full_name,
          status: row.status === "p" ? "Pending" : "Approved",
          description: row.narration,
          total: Number(row.total_amount || row.amount || 0).toFixed(2),
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
